﻿let $ = require('jquery');
let StickyHeader = require('./StickyHeader.js');

require('./Templates/Menu1/main.js');
require('./Templates/Menu2/main.js');
require('./Templates/MobileMenu/main.js');
require('./Templates/FollowUserInsideColumnSpace/main.js');
require('./Templates/FullWidthAndFloatRightOnTop/main.js');

var adjustHeaderTopPladeholderHeight = function () {
	let heightSum = 0;

	$('.header-with-placeholder-top').each(function () {
		heightSum += $(this).height();
	});
	$('.header-with-placeholder-top-placeholder').height(heightSum);
	var menuBar = $('.jnf-widget.jnf-widget-menu-1')[0];
	$('.sign-up-popup').css('top', $(menuBar).outerHeight() - 40);

};

let onWindowResize = function () {
		adjustHeaderTopPladeholderHeight();
};

//AE TOggle for MENU
$('.stick-to-page-top-and-hide-on-scroll').each(function (elementIndex, element) {
	new StickyHeader({
	    element: element,
	    secondLevelElement: $(element).find('.stick-to-page-top-on-further-scroll')
	});

});


if( !$("#hsi-body").length || $(window).width() > 960){
	$(window).on('resize', onWindowResize);
	adjustHeaderTopPladeholderHeight();
}

